export enum OttopilotBobcardWorkspaceCapabilityAccessOperation {
    create = "6487234c-5478-422c-acfb-59ba12845f59",
    read = "bfe5408d-0a1c-4eda-a4c0-7b8e7f60ce4b",
    update = "384a84eb-d1ae-44fd-ba43-5e9544a70873",
    delete = "b1bc8505-9980-4ccc-b102-ba9d8fc4e635",
}
